import { PdCollapse } from "./pd-collapse/PdCollapse.js";
//#region src/pd-collapse/pd-collapse.ts
var tag = "pd-collapse";
if (!customElements.get(tag)) customElements.define(tag, PdCollapse);
//#endregion
export { PdCollapse };
